enum UserRoles {
  ADMIN = 'InMotion.Admin',
  ORG_MANAGER = 'InMotion.OrganizationManager',
  CONTENT_MANAGER = 'InMotion.ContentManager',
  VIEWER = 'InMotion.Viewer',
}

export default UserRoles;
